import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";

/* ResizeObserver loop warnings are benign browser noise (layout settles one
   frame late) but CRA's dev overlay treats them as fatal errors. Debounce
   observer callbacks to the next animation frame so the loop never happens,
   and swallow any that still slip through. */
const debounceAnimationFrame = (callback) => {
  let frame = null;
  return (...args) => {
    if (frame) cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => callback(...args));
  };
};

if (typeof window !== "undefined" && window.ResizeObserver) {
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super(debounceAnimationFrame(callback));
    }
  };
}

window.addEventListener("error", (e) => {
  if (e.message && e.message.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
